<template>
  <li v-bind:class="[filter.Level != undefined ? 'filter-' + filter.Level : '']">
      <label>
          <input type="checkbox" v-model="filter.Checked" :disabled="state.status.isFetching"/>
          <div class="info-wrapper" v-if="filter.Level > 0">
              <span class="text">
                  {{ filter.Name }}
                  <span class="info">
                      ({{ filter.Count }})
                  </span>
              </span>
          </div>
          <span class="text" v-if="filter.Level == 0 || filter.Level == undefined">
              {{ filter.Name }}
              <span class="info">
                  ({{ filter.Count }})
              </span>
          </span>
      </label>
  </li>
</template>
<script>

  import { store } from './../store.js';

  export default {
      props: ['filter'],
      data: function () {
          return {
              state: store.state
          }
      },
      watch: {
          'filter.Checked': function () {
              store.filter();
          }
      }
  }
</script>